import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { ConfigService } from '../../config/config.service';
import { SessionService } from './session.service';
import { CommonDataService } from './common-data.service';
import { httpExtensionService } from './httpextension.service';
@Injectable()
export class ConfirmPurchase {

    constructor(private http: httpExtensionService, private config: ConfigService, private sessionService: SessionService, private commonDataService: CommonDataService) { }

    getMemberDetails() {
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.apiURI + this.config.getMemberDetails, {
            headers: headers
        })
    }

    addMemberAddress(userData) {
        let body = this.commonDataService.urlDataDecoded(userData);
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.addMemberAddress, body, {
            headers: headers
        })

    }

    getBenefactorList() {
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.getBenefactorList, {
            headers: headers
        })
    }

    makeOrder( stat){
        let user_token: string = this.sessionService.getToken();
        let _body = stat;
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);

        return this.http.post(this.config.makeOrder, _body, {
            headers: headers
        })
    }

    getOrderPrice(data) {
        let user_token: string = this.sessionService.getToken();
        let _body = data;
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);

        return this.http.post(this.config.getOrderPrice, _body, {
            headers: headers
        })
    }

    createMembershipSubscription(data) {
        let _body = data;
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.createMembershipSubscription, _body, {
            headers: headers
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/confirmpurchase.service.ts